import { useState } from 'react';
import { useDispatch } from 'react-redux';

//
import { setHeader } from '../../../../../../../Redux/slices/certificate';

//
import Image from '../../../molecules/Image';

/**
 *
 */
function RightLogo({ headerState, preview }) {
  const dispatch = useDispatch();

  const { rightLogo } = headerState;
  const { imgSrc, isVisible } = rightLogo;

  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleSave = (imageData) => {
    dispatch(
      setHeader({
        ...headerState,
        rightLogo: {
          imgSrc: imageData.file
        }
      })
    );
  };
  return (
    <div className={`${preview ? '' : 'c-container'} logo`}>
      <Image
        show={show}
        imgSrc={imgSrc}
        preview={preview}
        isVisible={isVisible}
        handleShow={handleShow}
        handleSave={handleSave}
        handleClose={handleClose}
      />
    </div>
  );
}

export default RightLogo;
